<template>
<div>
    <img class="flex justify-center items-center pl-8 mt-20 h-40 ml-20 mb-20" src="/images/logo2.png" alt="logo">
      <h2 class=" font-bold mr-8 ml-10 pt-5 pb-20 mt-6">My Closet is an app that helps people organize their garments and quickly choose their outfits on their phone.</h2>
</div>
</template>

<script>
export default {

}
</script>

<style>

</style>